// App-specific config

// Using CommonJS instead of ES2015+ export, because we also need to
// provide this object to Webpack in vue.config.js.
module.exports = {
  title: 'Scorecards',
  description: 'Scorecards',
  version: 'v1.6.0',
  author: 'VIER',
  url: 'sc.engage.vier.ai',
  links: {
    de: {
      imprint: 'https://www.vier.ai/impressum/',
      privacy: 'https://www.vier.ai/datenschutz/',
      agb: 'https://www.voixen.ai/de/rechtliches/agb',
      toc: 'https://www.voixen.ai/de/produkt/coachingbogennutzungsbedingungen',
      disclaimer: 'https://www.voixen.ai/de/rechtliches/haftungsausschluss'
    },
    en: {
      imprint: 'https://www.vier.ai/en/legal-notice/',
      privacy: 'https://www.vier.ai/en/data-protection/',
      agb: 'https://www.voixen.ai/en/legal/terms',
      toc: 'https://www.voixen.ai/en/product/scorecardtermsofuse',
      disclaimer: 'https://www.voixen.ai/en/legal/disclaimer'
    }
  }
}
